import { useState } from 'react'

import { UploadProgress } from '../model/constants'

const useUploadProgress = () => {
  const [uploadProgress, setUploadProgress] = useState(UploadProgress.Start)

  const isUploading = Boolean(
    uploadProgress && uploadProgress !== UploadProgress.Complete
  )

  return {
    uploadProgress,
    setUploadProgress,
    isUploading
  }
}

export { useUploadProgress }
